<!--
  @component
  Generates an SVG x-axis. This component is also configured to detect if your x-scale is an ordinal scale. If so, it will place the markers in the middle of the bandwidth.
 -->
 <script>
  import { getContext } from 'svelte';
  import { tweened } from "svelte/motion";
	import { cubicOut } from "svelte/easing";
  
  const { height, xScale, yRange, yScale } = getContext('LayerCake');

  export let formatTick;
  export let tick;
  export let yTicks;

  const xAnimationParameters = {
   duration: 500,
   easing: cubicOut,
   delay: 0,
  };

  $: yearStep = $xScale(new Date('2020')) - $xScale(new Date('2019'))

  // let tX = tweened($xScale(tick), xAnimationParameters);
  // $: targetX = $xScale(tick);
  // $: tX.set(targetX, xAnimationParameters);

</script>

<g class="tick" transform="translate({$xScale(tick)},{Math.max(...$yRange)})">
  <line class="gridline" y1={$height * -1} y2="0" x1="0" x2="0" />
  {#each yTicks as yTick}
    <line class="axis-intersect" y1={-$yScale(yTick) - 4} y2={-$yScale(yTick) + 4} x1="0" x2="0" />
  {/each}

  <text
    x={yearStep/2}
    y={16}
    dx=""
    dy=""
    text-anchor="middle"
  >
    {formatTick(tick)}
  </text
  >
</g>

<style lang="scss">
  .tick {
    font-weight: 200;
  }

  line,
  .tick line {
    stroke: #F3F3F3;
    stroke-dasharray: 2;
    opacity: 0.2;

    &.axis-intersect {
      stroke-dasharray: none;
      opacity: 0.3;
    }
  }

  .tick text {
    fill: #F3F3F3;
    opacity: 0.5;
    font-size: 12px;

    @media (min-width: $breakpoint-tablet-s) {
      font-size: 13px;
	  }
  }

  
</style>